import { createFileRoute } from '@tanstack/react-router'
import { AuditorPoliciesShell } from '@/components/auditor-center/AuditorPoliciesShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies'
)({
  component: AuditorPoliciesShell,
})
